//const AmazonCognitoIdentity = require('amazon-cognito-identity-js');
import axios from "axios";

import {getApiSitePrefix} from "./functions/SiteDefaults";
const apiSitePrefix = getApiSitePrefix();

const AccessControl = {
  userName: "",
  userAttributes: null,
  passwordChangeRequired: false,
  userRoles: [],
  userInfo: null,
};

// const getUserRoles = async (user) => {
//   //console.log("user: ", user.name, "AccessControl: ", AccessControl.userRoles);
//   try {
//     const {data} = await axios.get(
//       `${apiSitePrefix}/getuserroles/${user.sub}`
//     );
//
//     AccessControl.userRoles = data;
//     AccessControl.userName = user.name;
//     //console.log("user: ", user.name, "AccessControl: ", AccessControl.userRoles);
//   } catch (e) {
//     console.log(e.message);
//   }
// }

const getUserRoles = (auth0User) => {
  let userRoles = []

  //TODO: use the correct namespace to match the Rule in Auth0
  // namespace should be the value set in the 'namespace' variable of the Auth0 rule
  const nameSpace = `${process.env.REACT_APP_AUTH0_NAMESPACE}/roles`;
  userRoles = auth0User[nameSpace];
  return userRoles;
}


const userHasAccess = (user, requiredAccess) => {

  function haveRequiredRole(value, index, array) {
    if (requiredAccess.indexOf(value) >= 0) {
      return true;
    }
  }

  const userRoles = user[`${process.env.REACT_APP_AUTH0_NAMESPACE}/roles`];

  //console.log("required access: ", requiredAccess );
  //console.log("AccessControl User Roles is: ", userRoles);
  if (requiredAccess === undefined || !requiredAccess ||
      !userRoles || userRoles.length === 0)
    return false;

  if (userRoles) {
    return userRoles.some(haveRequiredRole);
  }

  return false;
}

const setUserInfo = (userInfo) => {
  if (userInfo)
    AccessControl.userInfo = userInfo;
}

const getUserInfo = () => {
    return AccessControl.userInfo;
}

const updateUserPassword = async (user, userName, currentPassword, newPassword) => {
  const data = {
    userId: user,
    userName: userName,
    currentPassword: currentPassword,
    newPassword: newPassword
  }
  try {
    const response = await axios.post(`${apiSitePrefix}/changepassword`, data);
    if (!response.data) {
      console.log('Could not change the user\'s password');
      return null;
    }
    return response.data;
  } catch (err) {
    console.log('Could not change the user\'s password: ', err);
    return null
  }
}

export
{
  AccessControl,
  getUserRoles,
  userHasAccess,
  setUserInfo,
  getUserInfo,
  updateUserPassword
}